import {
  Box,
  Button,
  Typography,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { fetchHotelSection } from '../../api/hotelinfoApi';
import HotelPolicyForm from './HotelPolicyForm';
import { hasFeature } from '../../permissions';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:7071/api';

export default function PolicySection({
  entries,
  setEntries,
  form,
  setForm,
  open,
  setOpen,
  handleSubmitEdit,
  handleDelete,
  propertyId,
  fetchEntries,
  allowedFeatures
}) {
  const [initialForm, setInitialForm] = useState(null);

  const getLocalAF = () => {
    try {
      return JSON.parse(localStorage.getItem('allowedFeatures') || '{}');
    } catch (e) {
      console.warn('[PolicySection] Failed to parse allowedFeatures from localStorage:', e);
      return {};
    }
  };

  const AF = allowedFeatures || getLocalAF();
  const canEdit = !!(AF?.policies?.editPolicy ?? hasFeature('policies.editPolicy'));

  useEffect(() => {
    console.log('[PolicySection] allowedFeatures (prop):', allowedFeatures);
    console.log('[PolicySection] allowedFeatures (localStorage):', getLocalAF());
    console.log('[PolicySection] AF (effective):', AF);
    console.log('[PolicySection] permissions ->', { canEdit, policies: AF?.policies });
  }, [allowedFeatures, canEdit, AF]);

  useEffect(() => {
    console.log('[🧾 Policy Entries]', entries);
  }, [entries]);

  useEffect(() => {
    if (entries?.length > 0) {
      setForm(entries[0]);
      setInitialForm(entries[0]);
    }
  }, [entries, setForm]);

  const isFormChanged = JSON.stringify(form) !== JSON.stringify(initialForm);

  const handleSave = async () => {
    if (!canEdit) {
      console.warn('[PolicySection] Blocked: edit without permission', { canEdit, AF });
      alert('You do not have permission to edit policies.');
      return;
    }
    console.log('[💾 Attempting to Save]', form);
    try {
      const result = await handleSubmitEdit?.({ ...form }, 'policies');
      console.log('[📥 handleEdit Result]', result);
      if (
        result?.success ||
        result?.status === 200 ||
        result?.data?.success
      ) {
        setOpen(false);
        fetchEntries?.();
      } else {
        console.warn('[❌ Save Failed]', result);
      }
    } catch (err) {
      console.error('[🔥 Save Exception]', err);
    }
  };

  return (
    <>

      <Box component={Paper} elevation={1} sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Property Policies
        </Typography>

        <HotelPolicyForm
          form={form}
          setForm={setForm}
          propertyId={propertyId}
          fetchEntries={fetchEntries}
          onSuccess={() => {}}
        />

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={!isFormChanged || !canEdit}
            sx={{ backgroundColor: (!isFormChanged || !canEdit) ? 'gray' : undefined }}
          >
            Save Changes
          </Button>
        </Box>
      </Box>

    </>
  );
}